import styled from 'styled-components';

export const Container = styled.section`
  background-color: #ffffff;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  color: #272643;
  margin-bottom: 1rem;
  text-align: center;
`;

export const Description = styled.p`
  color: #4D4D4D;
  font-size: 1.1rem;
  line-height: 1.5;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem;
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 400px;
  margin-bottom: 3rem;
`;

export const TeacherImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
  position: relative;
`;

export const RedCircle = styled.div`
  position: absolute;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: rgba(255, 82, 82, 0.7);
  top: 10%;
  left: 10%;
  z-index: 0;
`;

export const BlueSquare = styled.div`
  position: absolute;
  width: 35px;
  height: 35px;
  background-color: rgba(33, 150, 243, 0.7);
  top: 20%;
  right: 15%;
  z-index: 0;
`;

export const GreenCircle = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(76, 175, 80, 0.7);
  bottom: 25%;
  left: 20%;
  z-index: 0;
`;

export const OrangeSquare = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: rgba(255, 152, 0, 0.7);
  bottom: 15%;
  right: 20%;
  z-index: 0;
`;

export const TestimonialsContainer = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
  justify-content: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const TestimonialCard = styled.div`
  background-color: #f7f7f7;
  padding: 1.5rem;
  border-radius: 10px;
  width: 100%;
  max-width: 350px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;

export const Rating = styled.div`
  color: #FFD700;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
`;

export const TestimonialText = styled.p`
  color: #272643;
  font-size: 1rem;
  line-height: 1.4;
  font-style: italic;
  margin-bottom: 0.5rem;
`;

export const AuthorInfo = styled.p`
  color: #4D4D4D;
  font-size: 0.9rem;
  text-align: right;
  margin: 0;
`;

export const LearnMoreButton = styled.button`
  background-color: #2563EB;
  color: white;
  border: none;
  padding: 0.8rem 2.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1rem;
`;

export const DownloadButton = styled.button`
  background-color: #2563EB;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #1c51c7;
  }
`;

export const WebsiteLink = styled.a`
  display: block;
  color: #272643;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;
